import { render, staticRenderFns } from "./TheBooking.vue?vue&type=template&id=64147675&scoped=true"
import script from "./TheBooking.vue?vue&type=script&lang=ts"
export * from "./TheBooking.vue?vue&type=script&lang=ts"
import style0 from "./TheBooking.vue?vue&type=style&index=0&id=64147675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64147675",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsFormResponse: require('/usr/src/nuxt-app/components/elements/FormResponse.vue').default,ElementsInputWithValidation: require('/usr/src/nuxt-app/components/elements/InputWithValidation.vue').default,ElementsPrivacyCheckbox: require('/usr/src/nuxt-app/components/elements/PrivacyCheckbox.vue').default})
